import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Contact } from '../../model';
import { IPageInfo } from 'ngx-virtual-scroller';

@Component({
  selector: 'app-contacts-preview',
  templateUrl: './contacts-preview.component.html',
  styleUrls: ['./contacts-preview.component.scss']
})
export class ContactsPreviewComponent implements OnInit {
  @Input() contacts: Contact[] = [];
  @Input() showDelete: boolean = true;
  @Output() onRemoveContact = new EventEmitter<number>();

  scrollEvent: IPageInfo;

  ngOnInit() {
  }

  removeRecipient(i) {
    this.onRemoveContact.emit(i);
  }

}
